import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { QueryKey } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["memberApiOnboarding"] as QueryKey,
  id: (id: unknown) => [...keys.all(), id] as QueryKey,
};

export const memberApiOnboarding = {
  keys,
  queries: {
    id: (userId: string | undefined) => {
      return {
        queryKey: keys.id(userId),
        queryFn: async () => {
          return (
            await api.get<ClubOnboardingSettingsDTO>(
              `/customer/onboarding-settings`,
            )
          ).data;
        },
        enabled: !!userId,
      };
    },
  },
  infiniteQueries: {},
  mutations: {},
};
